import SmoothScroll   from 'smooth-scroll';
import ScrollTop      from './module/scrollTop';
import Clickable      from './module/clickable';
import MatchHeight    from './module/matchHeight';
import Gnav           from './module/gnav';
import ScrollPosition from './module/scrollPosition';


const scrollID = new SmoothScroll('.js-scroll', {
  speed: 400
});
const scrollTop      = new ScrollTop('.js-scrollTop');
const clickable      = new Clickable('.js-clickable');
const matchHeight    = new MatchHeight('.js-matchHeight', '.js-matchHeight__item');
const gnav           = new Gnav();
const scrollPosition = new ScrollPosition();
